import { GeneralRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";

export const generalService = {

    getTerms: async () => {
        return await fetchRequest({
            route: GeneralRoutesEnum.GENERAL_TERMS,
            method: "GET",
        });
    }
};
